function padUnit(value) {
  return String(value).padStart(2, '0');
}

function formatUnit(unit, value) {
  return unit === 'days' ? String(value) : padUnit(value);
}

function remainingParts(endMs) {
  const diff = endMs - Date.now();

  if (diff <= 0) {
    return null;
  }

  const totalSeconds = Math.floor(diff / 1000);

  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}

function tickUnit(el, nextText) {
  if (!el || el.textContent === nextText) {
    return;
  }

  el.textContent = nextText;
  el.classList.remove('is-ticking');
  void el.offsetWidth;
  el.classList.add('is-ticking');
}

function initPromoAreaCountdown(root) {
  if (root.nodeType !== Node.ELEMENT_NODE) {
    return;
  }

  const endAttr = root.getAttribute('data-end');
  const endMs = endAttr ? Date.parse(endAttr) : NaN;
  const unitEls = {
    days: root.querySelector('[data-unit="days"]'),
    hours: root.querySelector('[data-unit="hours"]'),
    minutes: root.querySelector('[data-unit="minutes"]'),
    seconds: root.querySelector('[data-unit="seconds"]'),
  };

  const expire = () => {
    root.classList.add('is-expired');
  };

  if (!endAttr || Number.isNaN(endMs)) {
    expire();
    return;
  }

  const tick = () => {
    const parts = remainingParts(endMs);

    if (!parts) {
      expire();
      return false;
    }

    Object.keys(unitEls).forEach((unit) => {
      tickUnit(unitEls[unit], formatUnit(unit, parts[unit]));
    });

    return true;
  };

  if (!tick()) {
    return;
  }

  const timer = window.setInterval(() => {
    if (!tick()) {
      window.clearInterval(timer);
    }
  }, 1000);
}

[...document.querySelectorAll('.PromoArea-countdown')].forEach((node) => {
  initPromoAreaCountdown(node);
});
